import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=6b350afe"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=6b350afe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports